import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService, ADMIN_MODULES } from "../admin.service";

@Component({
  selector: "app-admin-users-admin-view",
  templateUrl: "./admin-users-admin-view.component.html",
  styleUrls: ["./admin-users-admin-view.component.css"],
})
export class AdminUsersAdminViewComponent implements OnInit {
  adminView: boolean = true;
  adminData: any;
  adminFormGroup: FormGroup;
  file: any;
  profile_pic: any;
  token: any;
  minDob = new Date();
  public invalidDob: boolean = false;
  today: any;
  adminModules = ADMIN_MODULES;
  selectedModules: string[] = [];
  isLoading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminUsersAdminViewComponent>,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.adminData = this.data;
    this.adminFormGroup = this.formBuilder.group({
      name: ["", [Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z\\s]*$')]],
      username: ["", [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]],
      gender: [""],
      employee_id: [""],
      dob: [""],
      role: [""],
      mobile: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      is_sms_enabled: [false],
      is_active: [true],
    });
  }
  editUsers() {
    this.adminView = false;
    this.profile_pic = this.adminData.adminRegisterDetails.profile_pic;
    this.adminFormGroup.patchValue({
      name: this.adminData.adminRegisterDetails.name || "",
      username: this.adminData.username,
      gender: this.adminData.adminRegisterDetails.gender,
      dob: this.adminData.adminRegisterDetails.dob,
      employee_id: this.adminData.adminRegisterDetails.employee_id,
      role: this.adminData.adminRegisterDetails.role,
      mobile: this.adminData.mobile,
      email: this.adminData.email,
      is_sms_enabled: this.adminData.adminRegisterDetails.is_sms_enabled || false,
      is_active: this.adminData.adminRegisterDetails.is_active !== false,
    });
    this.selectedModules = this.adminData.adminRegisterDetails.permissions || [];
  }
  close() {
    this.matdialogref.close();
  }

  public onDateChnage(num: number) {
    if (num === 2 && this.adminFormGroup.value.dob > this.today) {
      this.invalidDob = true;
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.profile_pic = response.body.image_link;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  updateAdmin() {
    this.isLoading = true;
    const adminObj = {
      name: this.adminFormGroup.value.name,
      username: this.adminFormGroup.value.username,
      mobile: this.adminFormGroup.value.mobile,
      email: this.adminFormGroup.value.email,
      dob: this.adminFormGroup.value.dob,
      gender: this.adminFormGroup.value.gender,
      profile_pic: this.profile_pic,
      employee_id: this.adminFormGroup.value.employee_id,
      role: this.adminFormGroup.value.role,
      is_sms_enabled: this.adminFormGroup.value.is_sms_enabled,
      is_active: this.adminFormGroup.value.is_active,
      permissions: this.selectedModules,
    };

    this.services.adminUpdate(adminObj, this.token, this.data._id).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.status === 200 || response.status === 201) {
          this.matDialog.closeAll();
          this.snackBar.open("Admin Updated Successfully", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        this.isLoading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  toggleModule(moduleId: string) {
    const index = this.selectedModules.indexOf(moduleId);
    if (index > -1) {
      this.selectedModules.splice(index, 1);
    } else {
      this.selectedModules.push(moduleId);
    }
  }

  getModuleName(moduleId: string): string {
    const module = this.adminModules.find(m => m.id === moduleId);
    return module ? module.name : moduleId;
  }

  validateAlphaNumeric(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[a-zA-Z0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  validateAlphabetsAndSpaces(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    const target = event.target as HTMLInputElement;
    if (input === ' ' && target.selectionStart === 0) {
      event.preventDefault();
      return;
    }
    if (!/[a-zA-Z\s]/.test(input)) {
      event.preventDefault();
    }
  }

}
